<template>
  <b-container class="mb-4">
    <config-publisher
      ref="configPublisher"
      v-model="config"
      class="p-0"
      tool-name="EPG Configuration Tool"
      tool-icon-text="Electronic Programming Guide"
      :config-name="configName"
      :can-edit="canEpgContentConfigEdit"
      :can-publish="canEpgContentConfigPublish"
      :is-form-valid="isFormValid">
      <template slot="header" />
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Display">
            <epg-display
              v-if="config"
              ref="epgdisplay"
              :config="config"
              :can-edit="canEpgContentConfigEdit" />
          </b-tab>
          <b-tab title="Seasons">
            <b-card
              v-for="(season, index) in config.supportedSeasons"
              :key="index"
              class="mt-3">
              <seasons
                v-if="config.supportedSeasons"
                ref="form"
                :season="season"
                @season-update="onSeasonUpdate" />
              <b-btn
                variant="link"
                size="sm"
                class="float-right text-danger pt-1 pr-0"
                @click.prevent="onRemoveSeasonRange(index)">
                Remove
              </b-btn>
            </b-card>
            <b-btn
              variant="primary"
              style="float: right"
              class="mt-3 mb-3"
              @click.prevent="onAddSeasonRange">
              Add Season Range
            </b-btn>
          </b-tab>
        </b-tabs>
      </b-card>
    </config-publisher>
  </b-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ConfigPublisher from "@/components/ConfigPublisher"
  import EpgDisplay from "@/components/EPGConfig/EpgDisplay"
  import Seasons from "@/components/CalendarConfiguration/Seasons"

  export default {
    name: 'EpgConfiguration',
    components: {
      ConfigPublisher,
      EpgDisplay,
      Seasons,
    },
    data: () => ({
      assetPreviewLoadedRatio: 0,
      config: {},
      betaConfig: null,
      prodConfig: null,
      betaUrl: null,
      prodUrl: null,
      hasEpgErrors: false,
      validated: true,
      configName: "epgcontent",
    }),
    computed: {
      ...mapGetters([
        'betaEnvName',
        'liveEnvName',
        'isAdmin',
        'canEpgContentConfigEdit',
        'canEpgContentConfigPublish',
      ]),
    },
    async created() {
      this.validated = true
    },
    methods: {
      isFormValid() {
        let allValid = this.$refs.epgdisplay.isValid()
        this.config.supportedSeasons.forEach((it, idx) => {
          const form = this.$refs.form[idx]
          if (!form.isValid()) {
            allValid = false
          }
        })
        this.validated = allValid
        return allValid
      },
      onSeasonUpdate(season) {
        season.seasonStartDate = season.preSeasonStartDate
        season.seasonEndDate = season.postSeasonEndDate
        if (!season.showSpringTraining) {
          season.seasonStartDate = season.regularSeasonStartDate
        }
        if (!season.showPostSeason) {
          season.seasonEndDate = season.regularSeasonEndDate
        }
      },
      onAddSeasonRange() {
        this.config.supportedSeasons.push({
          hasWildCard: true,
          postSeasonEndDate: "",
          postSeasonStartDate: "",
          preSeasonEndDate: "",
          preSeasonStartDate: "",
          regularSeasonEndDate: "",
          regularSeasonStartDate: "",
          seasonEndDate: "",
          seasonId: "",
          seasonStartDate: "",
          showPostSeason: true,
          showSpringTraining: true,
        })
      },
      validateSeasonRange(season) {
        return season.seasonStartDate !== null && season.seasonStartDate.length > 0
            && season.seasonEndDate !== null && season.seasonEndDate.length > 0
            && season.preSeasonStartDate !== null && season.preSeasonStartDate.length > 0
            && season.preSeasonEndDate !== null && season.preSeasonEndDate.length > 0
            && season.regularSeasonStartDate !== null && season.regularSeasonStartDate.length > 0
            && season.regularSeasonEndDate !== null && season.regularSeasonEndDate.length > 0
            && season.postSeasonStartDate !== null && season.postSeasonStartDate.length > 0
            && season.postSeasonEndDate !== null && season.postSeasonEndDate.length > 0
            && season.seasonId !== null && season.seasonId.length > 0
            && season.hasWildCard !== null && season.showPostSeason !== null
            && season.showSpringTraining !== null
      },
      async onRemoveSeasonRange(index) {
        // Only prompt to delete if the range has been populated
        if (this.config.supportedSeasons.length >= index && this.validateSeasonRange(this.config.supportedSeasons[index])) {
          const modalConfirmed = await this.$confirm.open(`Are you sure you wish to delete this season range?`)
          if (!modalConfirmed) {
            return
          }
        }
        this.config.supportedSeasons.splice(index, 1)
      },
      async beforeRouteLeave(to, from, next) {
        if (this.$refs.configPublisher.configHasChanged()) {
          const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
          next(await this.$confirm.open(message))
        } else {
          next()
        }
      },
    },
  }
</script>
